import {OktaAuth} from "@okta/okta-auth-js"

const oktaConfig = {
	issuer: "https://indebted.okta.com",
	clientId: process.env.OKTA_CLIENT_ID,
	redirectUri: `${window.location.origin}/login/callback`,
	scopes: ["openid", "profile", "email"],
	pkce: true,
}

export const oktaAuth = new OktaAuth(oktaConfig)
